import { useState } from 'react';
import './AutoComplete.scss';
import SearchIcon from '../../Assets/Images/searchIcon.svg';
const AutoComplete = ({ suggestions }) => {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [input, setInput] = useState('');

  const onChange = e => {
    const userInput = e.target.value;

    // Filter our suggestions that don't contain the user's input
    const unLinked = suggestions.filter(
      suggestion =>
        suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

    setInput(e.target.value);
    setFilteredSuggestions(unLinked);
    setActiveSuggestionIndex(0);
    setShowSuggestions(true);
  };

  const onClick = e => {
    setFilteredSuggestions([]);
    setInput(e.target.innerText);
    // console.log(e.target.innerText);
    setActiveSuggestionIndex(0);
    setShowSuggestions(false);
  };

  const onKeyDown = e => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      setInput(filteredSuggestions[activeSuggestionIndex]);
      setFilteredSuggestions([]);
    }
  };

  const SuggestionsListComponent = () => {
    return filteredSuggestions.length ? (
      <ul className='suggestions'>
        {filteredSuggestions.map((suggestion, index) => {
          let className;
          // Flag the active suggestion with a class
          if (index === activeSuggestionIndex) {
            className = 'suggestion-active';
          }
          return (
            <li className={className} key={suggestion} onClick={onClick}>
              {suggestion}
            </li>
          );
        })}
      </ul>
    ) : (
      <div class='no-suggestions'>
        <em>No suggestions, you're on your own!</em>
      </div>
    );
  };

  return (
    <>
      <div className='autoComplete'>
        <input
          className='autoComplete-input'
          type='text'
          onChange={onChange}
          onKeyDown={onKeyDown}
          value={input}
          placeholder='Search...'
        />
        <img
          className='autoComplete-searchIcon'
          src={SearchIcon}
          alt='Search Icon'
        />
      </div>
      {showSuggestions && input && <SuggestionsListComponent />}
    </>
  );
};
export default AutoComplete;
